"use strict";
export default {
  setPageFromUnidentifiedDocument: function(model) {
    const unidentifiedDocument = _.findWhere(
      model.activeDocuments(),
      { type: null }
    );
    if (unidentifiedDocument) {
      model.selectPage(unidentifiedDocument.pages[0]);
      return true;
    }
  }
};
